export default __webpack_public_path__ + "acc51801874284cf9e7f3858511478f1.png";